<template>
  <van-tabbar v-model="active" safe-area-inset-bottom route>
    <van-tabbar-item
      icon="home-o"
      replace
      :to="home"
    >首页</van-tabbar-item>
    <!-- <van-tabbar-item
      icon="fire-o"
      replace
      :to="discovery"
    >发现</van-tabbar-item> -->
    <!-- <van-tabbar-item
      icon="fire-o"
      replace
      :to="publicEpisodes"
    >公播</van-tabbar-item> -->
    <van-tabbar-item
      icon="gem-o"
      info=""
      replace
      :to="premiumEpisodes"
    >私房课</van-tabbar-item>
    <!-- <van-tabbar-item
      icon="comment-o"
      replace
      :to="hotCommentsList"
    >热评</van-tabbar-item> -->
    <van-tabbar-item
      icon="contact"
      :dot="false"
      replace
      :to="userCenter"
    >我的</van-tabbar-item>
  </van-tabbar>
</template>

<script>
  import Vue from 'vue'
  import { Tabbar, TabbarItem } from 'vant'
  Vue.use(Tabbar).use(TabbarItem)
  export default {
    props: {
      slug: String
    },
    data () {
      return {
        active: 0
      }
    },
    watch: {
    },
    computed: {
      home () {
        let to = {
          name: `ShowDetail`,
          params: { slug: this.slug }
        }
        return to
      },
      discovery () {
        let to = {
          name: `Discovery`,
          params: { slug: this.slug }
        }
        return to
      },
      publicEpisodes () {
        let to = {
          name: 'PublicEpisodes',
          params: { slug: this.slug }
        }
        return to
      },
      premiumEpisodes () {
        let to = {
          name: 'PremiumEpisodes',
          params: { slug: this.slug }
        }
        return to
      },
      hotCommentsList () {
        let to = {
          name: 'HotCommentsList',
          params: { slug: this.slug }
        }
        return to
      },
      userCenter () {
        let to = {
          name: `UserCenterIndex`,
          params: { slug: this.slug }
        }
        return to
      }
    },
    methods: {
    }
  }
</script>

<style lang="css" scoped>
</style>
